import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from "ngx-toastr";
import {  ActivatedRoute, Router } from "@angular/router";
import { UsuarioService } from "src/app/core/services/usuario-service";
@Component({
  selector: "ativacao",
  templateUrl: "./ativacao.component.html",
  styleUrls: ["./ativacao.component.css"],
})
export class PageAtivacaoComponent implements OnInit{
  public form: FormGroup;
  public error: Boolean = false;
  public submitted: Boolean = false;
  public clienteValido: Boolean = false;
  public loading: Boolean = true;
  public erroMsg: String = '';
  public hash: String = '';
  public termsLink  : String = '';
  public login: string = '';
  public nome: string = '';  
  
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public usuarioService: UsuarioService,
    private router: Router,
    public toastService: ToastrService,
  ) {
    this.initializeForm();
  }
  
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.hash = params.hash;
      this.usuarioService.getClienteValido(
        params.hash,
        (res: any) => {
          this.clienteValido = true;
          this.loading = false;
          this.termsLink = res.lgpd || '';
          this.nome = res.nome || '';
          this.login = res.email || '';
        },
        (err: any) => {
          this.clienteValido = false;
          this.loading = false;
          this.erroMsg = err.error.detail || $localize`Link inválido ou expirado.`;
        }
      );
    });
  }

  private initializeForm(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],   
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      consent_lgpd: [false, Validators.requiredTrue]
    }, { 
      validators: this.passwordMatchValidator 
    });
  }

  // Validador customizado para comparar senhas
  private passwordMatchValidator(form: FormGroup): {[key: string]: any} | null {
    const password = form.get('password');
    const confirmPassword = form.get('confirmPassword');
    
    if (password && confirmPassword && password.value !== confirmPassword.value) {
      confirmPassword.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      if (confirmPassword && confirmPassword.errors?.['passwordMismatch']) {
        const errors = { ...confirmPassword.errors };
        delete errors['passwordMismatch'];
        confirmPassword.setErrors(Object.keys(errors).length > 0 ? errors : null);
      }
    }
    return null;
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;
    let payload = this.form.value;
    delete payload.confirmPassword;
    payload.hash = this.hash;
    payload.clientInfo = {  
      ip: '', // Você pode preencher com o IP real se necessário
      userAgent: navigator.userAgent
    };
    if (!this.form.valid) {
      this.error = true;
      this.markAllFieldsAsTouched();
      return;
    }

    if (this.form.hasError('passwordMismatch')) {
      this.toastService.warning($localize`As senhas não conferem`, $localize`Cliente`, {
        positionClass: "toast-bottom-left",
      });
      return;
    }

    this.usuarioService.ativaCliente(
      this.form.value,
      (res: any) => {
        this.toastService.success(res.detail, $localize`Cliente`, {
          positionClass: 'toast-bottom-left',
        });
    
        // Aguarda 1 segundo antes de redirecionar
        setTimeout(() => {
          this.router.navigate(['/']);
        }, 1000);
      },
      (err: any) => {
        this.toastService.error(err.error.detail, $localize`Cliente`, {
          positionClass: 'toast-bottom-left',
        });
        console.error(err);
      }
    );
    
    // Descomente e ajuste quando sua API estiver pronta
    /*
    try {
      const response = await fetch('/api/ativar-usuario', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hash, email, password })
      });

      if (response.ok) {
        this.toastService.success('Conta ativada com sucesso!');
      } else {
        this.toastService.error('Erro ao ativar conta. Verifique o link ou tente novamente.');
      }
    } catch (err) {
      this.toastService.error('Erro na requisição. Tente novamente mais tarde.');
      console.error(err);
    }
    */
  }

  private markAllFieldsAsTouched(): void {
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key)?.markAsTouched();
    });
  }

  // Getters para facilitar o acesso no template
  get email() { return this.form.get('email'); }
  get password() { return this.form.get('password'); }
  get confirmPassword() { return this.form.get('confirmPassword'); }
  get consent_lgpd() { return this.form.get('consent_lgpd'); }
}